import { AfterViewChecked, Directive, ElementRef, HostListener, OnDestroy, OnInit, Renderer2 } from '@angular/core';

@Directive({
  selector: 'textarea[necAutoSize]'
})
export class NecAutoSizeDirective implements OnInit, AfterViewChecked, OnDestroy {

  mySpan: any;

  MAX_CHECK_COUNT = 10;

  // for IE 7 or 8
  @HostListener('propertychange', ['$event.target'])
  OnPropertyChange() {
    this.resize();
  }

  @HostListener('input', ['$event.target'])
  OnInput() {
    this.resize();
  }

  @HostListener('keyup', ['$event.target'])
  OnKeyUp() {
    this.resize();
  }

  @HostListener('change', ['$event.target'])
  OnChange() {
    this.resize();
  }

  constructor(private el: ElementRef,
              private renderer: Renderer2) {
  }

  ngOnInit() {
    const parent = this.el.nativeElement.parentNode;

    // åå»ºåè£¹textareaçdiv
    const divElement = this.renderer.createElement('div');
    divElement.innerHTML = '<pre><span></span><br><br></pre>';
    this.renderer.addClass(divElement, 'nec-flex-text-wrap');

    this.mySpan = divElement.getElementsByTagName('span')[0];

    this.renderer.insertBefore(parent, divElement, this.el.nativeElement);
    divElement.appendChild(this.el.nativeElement);
  }

  ngAfterViewChecked() {
    // åæ¶ä¿è¯åå§åå±å¼ãä»¥åé¡µé¢æ§è½
    if (this.MAX_CHECK_COUNT > 0) {
      this.resize();
      this.MAX_CHECK_COUNT--;
    }
  }

  ngOnDestroy() {
    this.mySpan = null;
  }

  // åæ­¥spanåå®¹
  private resize() {
    if (this.mySpan.innerHTML !== this.el.nativeElement.value) {
      this.mySpan.innerHTML = this.el.nativeElement.value.replace(/\r?\n/g, '\r\n');
    }
  }

}
